var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaderModeFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3535,
    y: 25,
    width: 47,
    height: 30.4154,
    rx: 3,
    transform: "rotate(90 60.3535 25)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.416,
    y: 25,
    width: 47,
    height: 30.4154,
    rx: 3,
    transform: "rotate(90 28.416 25)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.707,
    y: 25,
    width: 47,
    height: 30.4154,
    rx: 3,
    transform: "rotate(90 132.707 25)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.77,
    y: 25,
    width: 47,
    height: 30.4154,
    rx: 3,
    transform: "rotate(90 100.77 25)",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaderModeFilm);
export default __webpack_public_path__ + "static/media/reader-mode-film.e8c92a7f50f3bdc2779dc30539f5c738.svg";
export { ForwardRef as ReactComponent };